import * as urls from 'utils/urls'

export const replaceMap = {
  registration: urls.REGISTRATION,
  startrecover: urls.RECOVERY,
  recover: urls.RECOVERY,
  unblock: urls.UNBLOCK,
  deletemail: urls.DELETE_MAIL,
  confirmemail: urls.ADD_EMAIL,
  changeexternal: urls.DEFAULT_CHAMP
}

export default function fallbackUrl({location, history}) {
  const {hash, search} = location
  const replaceRoute = replaceMap[hash.replace(/[/#]/g, '')]

  if (hash) {
    history.replace(`${replaceRoute || urls.PROFILE}${search}`)
  }
}
